import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  settings: null
}

const getters = {
  attendeeReminders: state => state.settings
}

const actions = {
  async getAttendeeReminders ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.attendeeReminders.getAttendeeReminders())
      commit(types.SET_ATTENDEE_REMINDERS_SETTINGS, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error during getting Attendee reminders Email Templates List')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editAttendeeReminders ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.attendeeReminders.editAttendeeReminders(), { ...payload })
      await commit(types.SET_ATTENDEE_REMINDERS_SETTINGS, [])
      await this.dispatch('getAttendeeReminders')
      this.dispatch('showResultSuccessMessage')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Error during update Attendee Reminders settings')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async sendAttendeeReminders ({ commit }, attendeeId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.attendeeReminders.sendAttendeeReminders(attendeeId))
      this.dispatch('showResultSuccessMessage', 'Reminder was successfully sent!')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Error during send reminder for attendee!')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async resetEmailTemplate  ({ commit }, registrationStatus) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.attendeeReminders.resetEmailTemplate(registrationStatus))
      await this.dispatch('showResultSuccessMessage', 'Reset successfully')
      await commit(types.SET_ATTENDEE_REMINDERS_SETTINGS, [])
      await this.dispatch('getAttendeeReminders')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Reset error')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_ATTENDEE_REMINDERS_SETTINGS] (state, { settings }) {
    state.settings = settings
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/attendeeReminders.js